export default __webpack_public_path__ + "static/media/Armstraps of the Nebulous.562b3066.jpg";